/* Browup order bumps.

   The original Shipping Protection control is wired straight into the theme's
   formVariants mechanism and is hardcoded to one variant id. Rather than
   rewrite that controller and risk add-to-cart, this module runs alongside it:
   it clones the protection row's markup for each extra bump so the styling
   matches for free, keeps its own checked state, and attaches the chosen
   bumps in a follow-up /cart/add.js after the main add succeeds.

   Nothing here touches formVariants, so there is no way for a bump to be
   added twice. */
(function () {
  'use strict';

  var BUMPS = [
    { id: 54018931294319, label: 'Priority Dispatch',       price: '$3.99', was: '$7.95',
      icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M13.2 2.5L5.4 13.6h5.5l-.5 7.9 8-11.2h-5.5z\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linejoin=\"round\"/></svg>" },
    { id: 54018931556463, label: '30-Day Damage Guarantee', price: '$2.99', was: '$5.99',
      icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\"><circle cx=\"12\" cy=\"9.5\" r=\"6.3\" stroke=\"currentColor\" stroke-width=\"1.7\"/><path d=\"M9.2 9.6l2 2 3.7-3.8\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M8.7 15.2L7.5 21.4l4.5-2.3 4.5 2.3-1.2-6.2\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linejoin=\"round\"/></svg>" }
  ];

  var state = {};
  BUMPS.forEach(function (b) { state[b.id] = true; });   // default on, one tap to remove

  var OF = window.fetch.bind(window);

  /* ---------- rendering ---------- */

  function rowFor(bump, template) {
    var el = template.cloneNode(true);
    el.removeAttribute('data-browup-shipping-protection');
    el.setAttribute('data-browup-bump', String(bump.id));
    el.setAttribute('aria-checked', String(!!state[bump.id]));

    var label = el.querySelector('.browup-shipping-protection__label');
    if (label) label.textContent = bump.label;

    var price = el.querySelector('.browup-shipping-protection__price');
    if (price) price.innerHTML = '<strong>' + bump.price + '</strong> <s>' + bump.was + '</s>';

    // Keep the wrapper (that is where the sizing and colour live) and swap only
    // the drawing inside it, so each bump reads as its own thing.
    var mark = el.querySelector('.browup-shipping-protection__shield');
    if (mark && bump.icon) mark.innerHTML = bump.icon;

    return el;
  }

  function render() {
    var templates = document.querySelectorAll('[data-browup-shipping-protection]');

    Array.prototype.forEach.call(templates, function (template) {
      var anchor = template;

      BUMPS.forEach(function (bump) {
        // One row per bump per bundle card, inserted once.
        var parent = template.parentNode;
        if (!parent) return;

        var existing = parent.querySelector('[data-browup-bump="' + bump.id + '"]');
        if (existing) {
          existing.setAttribute('aria-checked', String(!!state[bump.id]));
          anchor = existing;
          return;
        }

        var row = rowFor(bump, template);
        if (anchor.nextSibling) parent.insertBefore(row, anchor.nextSibling);
        else parent.appendChild(row);
        anchor = row;
      });
    });
  }

  function sync() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-browup-bump]'), function (el) {
      el.setAttribute('aria-checked', String(!!state[Number(el.getAttribute('data-browup-bump'))]));
    });
  }

  document.addEventListener('click', function (event) {
    var row = event.target.closest && event.target.closest('[data-browup-bump]');
    if (!row) return;
    event.preventDefault();
    event.stopPropagation();
    var id = Number(row.getAttribute('data-browup-bump'));
    state[id] = !state[id];
    sync();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== ' ' && event.key !== 'Enter') return;
    var row = event.target.closest && event.target.closest('[data-browup-bump]');
    if (!row) return;
    event.preventDefault();
    var id = Number(row.getAttribute('data-browup-bump'));
    state[id] = !state[id];
    sync();
  }, true);

  /* ---------- attaching to the cart ---------- */

  function chosen() {
    return BUMPS.filter(function (b) { return state[b.id]; }).map(function (b) { return b.id; });
  }

  function alreadyInCart(cart, id) {
    return (cart.items || []).some(function (it) { return it.variant_id === id; });
  }

  function attach() {
    var want = chosen();
    if (!want.length) return Promise.resolve();

    return OF('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = want
          .filter(function (id) { return !alreadyInCart(cart, id); })
          .map(function (id) { return { id: id, quantity: 1 }; });

        if (!items.length) return null;

        return OF('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .catch(function () { /* a bump must never block the real add */ });
  }

  /* The theme's product form captures window.fetch when its module loads,
     which happens before this file runs - wrapping fetch here would never see
     the add. Hooking submit in the capture phase always fires, then we wait
     for the kit to actually land in the cart before attaching the bumps. */
  function afterAdd() {
    var tries = 0;

    function poll() {
      tries += 1;
      return OF('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasKit = (cart.items || []).some(function (it) {
            return /Perfect Eyebrows in 5 seconds/.test(it.title);
          });
          if (hasKit) return attach().then(refreshDrawer);
          if (tries < 12) return new Promise(function (res) { setTimeout(res, 500); }).then(poll);
          return null;
        })
        .catch(function () { /* never block the real add */ });
    }

    return poll();
  }

  /* The drawer rendered from the response of the theme's own add request, so
     it does not know about bumps added after. Ask Shopify for a fresh render. */
  function refreshDrawer() {
    return OF('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: {}, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (parsed) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(parsed);
      })
      .catch(function () { /* cosmetic only */ });
  }

  /* WHERE THE BUMPS SIT IN THE CART AND AT CHECKOUT.
     Shopify lists cart lines newest-first, and the checkout summary mirrors the cart
     line for line - both measured. The bumps used to be attached only AFTER the kit had
     landed, which made them the newest lines and floated them above the product in the
     checkout summary, while Shipping Protection - added earlier in the flow - sat
     correctly underneath it. They are now added BEFORE the kit: the click is held,
     attach() runs, then the click is replayed.
     This is deliberately fail-open. There is a hard 900ms cap, and an error, a timeout
     or anything unexpected releases the click anyway, because an order bump must never
     cost a sale. The submit handler below still runs afterwards as a backstop for
     anything that did not land in time. */
  var replaying = false;
  document.addEventListener('click', function (event) {
    if (replaying) { replaying = false; return; }
    try {
      var btn = event.target && event.target.closest && event.target.closest(
        'button[name="add"], .product-form__submit, button[type="submit"], input[type="submit"]');
      if (!btn || btn.disabled) return;
      // The quantity-break buy box does NOT wrap its ADD TO CART in a
      // form[action="/cart/add"], so requiring one made this handler bail every time
      // and the bumps ended up attached AFTER the kit -> above it in the summary.
      var form = btn.closest('form[action*="/cart/add"]');
      var label = (btn.innerText || btn.value || '');
      if (!form && !/add to cart|add to bag/i.test(label)) return;
      if (!chosen().length) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      var released = false;
      var release = function () {
        if (released) return;
        released = true;
        replaying = true;
        try { btn.click(); } catch (e) { try { if (form) form.submit(); } catch (e2) { /* nothing left */ } }
      };
      // Cart and checkout list lines NEWEST FIRST, so the kit must be the LAST line
      // created to sit at the top of the order summary. Measured on the live cart:
      // bumps added first -> KIT, eBook, Shipping Protection, Priority, 30-Day.
      // The fail-open timer must outlast attach() (a /cart.js GET plus a
      // /cart/add.js POST), or the form wins the race and the bumps land on top.
      setTimeout(release, 3000);
      attach().then(release, release);
    } catch (e) { /* never stand between the customer and the cart */ }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    afterAdd();
  }, true);

  function boot() {
    render();
    var host = document.querySelector('.quantity-breaks-container');
    if (!host) return;
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(render, 80); })
      .observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();


/* Browup: reconcile orphaned add-ons at page load.
   The theme only cascades add-on removal when the kit is removed through its own
   cart UI. A cart mutated any other way (API call, sold-out line dropped, stale
   session) can survive with add-ons and no kit. This sweeps that on every load. */
(function () {
  var RELOAD_FLAG = 'browupAddonSweepReloaded';
  function sweep() {
    var enforce = window.enforceBrowupCartDependencies;
    if (typeof enforce !== 'function') return;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (!state || !state.items || !state.items.length) { try { sessionStorage.removeItem(RELOAD_FLAG); } catch (e) {} return; }
        var hasKit = state.items.some(function (i) {
          return i.handle === 'browup-stamp' || String(i.product_title || '').indexOf('Perfect Eyebrows in 5 seconds') !== -1;
        });
        if (hasKit) { try { sessionStorage.removeItem(RELOAD_FLAG); } catch (e) {} return; }
        var addonIds = ['53865744007279','53774624981103','54018931294319','54018931556463'];
        var hasAddon = state.items.some(function (i) { return addonIds.indexOf(String(i.variant_id)) !== -1; });
        if (!hasAddon) return;
        return enforce(state).then(function () {
          if (!/^\/cart/.test(window.location.pathname)) return;
          var already = false;
          try { already = sessionStorage.getItem(RELOAD_FLAG) === '1'; sessionStorage.setItem(RELOAD_FLAG, '1'); } catch (e) {}
          if (!already) window.location.reload();
        });
      })
      .catch(function () { /* never block the page */ });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', sweep); } else { sweep(); }
})();
